import { createSlice } from '@reduxjs/toolkit';

import { Article } from '@/types/article';
import * as asyncActions from './asyncActions';

type State = {
  items: Article[];
  readArticleIds: number[];
};

const initialState: State = {
  items: [],
  readArticleIds: [],
};

const slice = createSlice({
  name: 'article',
  initialState,
  reducers: {
    markAllAsRead(state) {
      state.readArticleIds = Array.from(
        new Set([...state.readArticleIds, ...state.items.map((a) => a.id)]),
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(asyncActions.fetchAll.fulfilled, (state, action) => {
      state.items = Array.isArray(action.payload.articles)
        ? action.payload.articles
        : [];
    });
  },
});

export const actions = slice.actions;
export default slice.reducer;
